import { create } from 'zustand';

interface TimelineState {
  visible: boolean;
  height: number;
  pixelsPerSecond: number; // timeline zoom
  // Actions
  toggle: () => void;
  show: () => void;
  hide: () => void;
  setHeight: (h: number) => void;
  setPixelsPerSecond: (pps: number) => void;
  zoomIn: () => void;
  zoomOut: () => void;
}

const MIN_HEIGHT = 96;
const MAX_HEIGHT = 360;
const DEFAULT_HEIGHT = 180;

const MIN_PPS = 40;
const MAX_PPS = 600;
const DEFAULT_PPS = 100;

export const useTimelineStore = create<TimelineState>((set) => ({
  visible: false,
  height: DEFAULT_HEIGHT,
  pixelsPerSecond: DEFAULT_PPS,

  toggle: () => set((s) => ({ visible: !s.visible })),
  show: () => set({ visible: true }),
  hide: () => set({ visible: false }),

  setHeight: (h) => set({ height: Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, h)) }),
  setPixelsPerSecond: (pps) => set({ pixelsPerSecond: Math.max(MIN_PPS, Math.min(MAX_PPS, pps)) }),

  zoomIn: () =>
    set((s) => ({ pixelsPerSecond: Math.min(MAX_PPS, Math.round(s.pixelsPerSecond * 1.5)) })),
  zoomOut: () =>
    set((s) => ({ pixelsPerSecond: Math.max(MIN_PPS, Math.round(s.pixelsPerSecond / 1.5)) })),
}));
